import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ roles }) {
  const { user, token, loading, refreshMe } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (token && !user && !loading) refreshMe();
  }, [token, user, loading, refreshMe]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (loading && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--brand-bg)]">
        <div className="text-sm text-muted-foreground">Loading workspace…</div>
      </div>
    );
  }
  if (roles && user && !roles.includes(user.role)) {
    const fallback = user.role === 'super_admin' ? '/super-admin' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
}
